
import { useTranslation } from "react-i18next";


import arrowRightWLImg from '../assets/arrowRightWL.png'

const InputTitle = ({ title, required }) => {
  const { t } = useTranslation();

  return (
    <p className=" text-sm font-bold mb-2">{t(title)} {required && <span className="text-red1">*</span>}</p>
  )
}
export default InputTitle